module.exports = __webpack_public_path__ + "fi.1b298415.svg";